import { Btn, H4, Image, P, UL, LI } from "../../../../AbstractElements";
import { Close, SomethingWentWrong } from "../../../../utils/Constant";
import { dynamicImage } from "../../../../Service";
import CommonModal from "../../../Ui-Kits/Modal/Common/CommonModal";
import { toast } from "react-toastify";
import apiRequestHelper from "../../../../utils/apiRequestHelper";
import { useLocation } from "react-router-dom";
interface Props {
  isOpen: boolean;
  toggle: () => void;
  blogId: number;
  onDeleteSuccess: () => void;
  url: string;
}

const CenteredModal = ({
  isOpen,
  url,
  toggle,
  blogId,
  onDeleteSuccess,
}: Props) => {
  const handleDelete = async () => {
    try {
      await apiRequestHelper.del(`${url}/${blogId}`);
      const message = url.includes("authors")
        ? "Author deleted successfully."
        : url.includes("users")
        ? "User deleted successfully."
        : "Blog deleted successfully.";
      toast.success(message);
      toggle(); // Close modal
      onDeleteSuccess(); // Notify parent to refresh list
    } catch (error: any) {
      toast.error(
        error?.response?.data?.messages?.[0]?.message ||
          "Failed to delete blog."
      );
    }
  };

  return (
    <CommonModal centered isOpen={isOpen} toggle={toggle}>
      <div className="modal-toggle-wrapper">
        <UL className="modal-img">
          <LI className="text-center">
            <Image src={dynamicImage("gif/danger.gif")} alt="error" />
          </LI>
        </UL>
        <H4 className="text-center pb-4">
          Are you sure you want to delete this{" "}
          {url.includes("authors")
            ? "Author. This action can delete all blogs related to this author."
            : url.includes("users")
            ? "User"
            : "Blog"}
          ?
        </H4>
        <div className="d-flex justify-content-center gap-3">
          <Btn color="danger" onClick={handleDelete}>
            Delete
          </Btn>
          <Btn color="success" onClick={toggle}>
            {Close}
          </Btn>
        </div>
      </div>
    </CommonModal>
  );
};

export default CenteredModal;
